import { Skeleton as ChakraSkeleton, SkeletonProps } from "@chakra-ui/react";

export const Skeleton = (props: SkeletonProps) => {
  return (
    <ChakraSkeleton startColor="gray.100" endColor="gray.200" {...props} />
  );
};
